module.exports = __webpack_public_path__ + "static/media/leafy_jeff.d6a63afc.jpg";